import { defineStyle } from '@chakra-ui/react';
export const textarea_base_style = defineStyle({
    border: '2px dashed', // change the appearance of the border
    borderRadius: 0, // remove the border radius
    fontWeight: 'semibold', // change the font weight
});
